import Glide, { Swipe } from '@glidejs/glide/dist/glide.modular.esm';
import { isTabletSize, isSubscribed } from '../functions';

let GlideInstance;

export default {

	init: function() {

		// calendar that's needs a carousel only exists
		// if doctor is subscribed
		if (isSubscribed()) {

			if (isTabletSize()) {

                var appointments = $('.firstDayContainer').length;

                // Check if there is any appointments or the calendar is empty
                if (! appointments) {
                    // Stop, otherwise Glide throw's an exception
                    // [Glide warn]: Root element must be a existing Html node
                    return;
                }

                if ($('.firstDayThatHasAppointmentsInCalendar').length) {

                    var date        = $('.firstDayThatHasAppointmentsInCalendar li')[0].dataset.date;

                    var cuurent_day = $('.cuurent_day').val();

                    var $nextAvailability = $('.firstDayThatHasAppointmentsInCalendar')
                                            .find('.availability-message-container');

                    if (date != cuurent_day) {
                        $nextAvailability.show();
                        $('.schedulesContainer').append($nextAvailability);
                    } else {
                        $nextAvailability.remove();
                    }
                }

				// Add classes

				$('.firstDayContainer').addClass('glide');
				$('.firstDayWrapper').addClass('glide__track').attr('data-glide-el', 'track');
				$('.firstDayUl').addClass('glide__slides');
				$('.firstDayUl li').addClass('glide__slide');

				// then intantiate

				GlideInstance = new Glide('.glide', {

					perView: 6,
					gap: 0

				}).mount({ Swipe });

			} else {

				$('.firstDayContainer').removeClass('glide');
				$('.firstDayWrapper').removeClass('glide__track').removeAttr('data-glide-el');
				$('.firstDayUl').removeClass('glide__slides');
				$('.firstDayUl li').removeClass('glide__slide');
			}

			return GlideInstance;
		}
	}
}
